import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { UserService } from '../../user/user.service';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ISlots } from './islots';
import { UserAvailabilityPayload, UserAvalibility } from '../../user/iusers';

@Component({
  selector: 'app-availability',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    MatInputModule,
    FormsModule,
    TablerIconsModule,
    MatTimepickerModule,
    TranslateModule
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './availability.component.html',
  styleUrl: './availability.component.scss'
})
export class AvailabilityComponent implements OnInit {
  weeks = [
    { day: 'SUN', slots: [{ startTime: '', endTime: '' }], isChecked: false },
    { day: 'MON', slots: [{ startTime: '', endTime: '' }], isChecked: false },
    { day: 'TUE', slots: [{ startTime: '', endTime: '' }], isChecked: false },
    { day: 'WED', slots: [{ startTime: '', endTime: '' }], isChecked: false },
    { day: 'THU', slots: [{ startTime: '', endTime: '' }], isChecked: false },
    { day: 'FRI', slots: [{ startTime: '', endTime: '' }], isChecked: false },
    { day: 'SAT', slots: [{ startTime: '', endTime: '' }], isChecked: false }

  ];
  selectedWeeks: number[] = [];
  @Output() availability: EventEmitter<any> = new EventEmitter();
  @Input() userId: number;
  @Input() userRole: string[] = [];
  check_startTime: string | number;
  check_endTime: string | number;

  constructor(
    private toastr: ToastrService,
    private _userService: UserService,
    private translate: TranslateService,
  ) {
  }
  ngOnInit(): void {
    if (this.userId) {
      this._userService.getUserAvalibility(this.userId).subscribe((response) => {
        const availability = response.result;

        const groupedAvailability = availability['reduce']((acc: any[], curr: { day: string; startTime: string; endTime: string; }) => {
          let existingDay = acc.find(item => item.day === curr.day);

          if (!existingDay) {
            existingDay = { day: curr.day, isChecked: true, slots: [] };
            acc.push(existingDay);
          }
          existingDay.slots.push({
            startTime: this.convertTimeStringToDate(curr.startTime),
            endTime: this.convertTimeStringToDate(curr.endTime)
          });

          return acc;
        }, []);

        this.weeks = this.weeks.map(week => {
          const matchedData = groupedAvailability.find((item: { day: string; }) => item.day === week.day);
          return matchedData ? matchedData : week;
        });
      });
    }

  }

  addSlot(index: number) {
    const startchecktime = this.weeks[index].slots.some(a => !a.startTime);
    const endchecktime = this.weeks[index].slots.some(a => !a.endTime);
    if (startchecktime || endchecktime) {
      this.toastr.error(this.translate.instant('TIME_EMPTY'));
      return;
    }
    let lastSlot = this.weeks[index].slots[this.weeks[index].slots.length - 1];
    let endtimeFill = lastSlot?.endTime || '';
    this.weeks[index].slots.push({ startTime: endtimeFill, endTime: '' });

  }

  removeSlot(dayIndex: number, slotIndex: number) {
    this.weeks[dayIndex].slots.splice(slotIndex, 1);
  }

  updatetime(event: Event, slot: ISlots, type: 'start' | 'end') {
    if (slot.startTime && slot.endTime) {
      this.check_startTime = this.convertToMinutes(new Date(slot.startTime));
      this.check_endTime = this.convertToMinutes(new Date(slot.endTime));

      if (this.check_startTime >= this.check_endTime) {
        this.toastr.error(this.translate.instant('TIME_COMPARE'))
      } else {
        slot.error = '';
      }
    }
  }

  onTimepickerChange(value: string, slot: ISlots, type: 'start' | 'end') {
    // Apply rounding and validation if needed (optional)
    const event = { target: { value } } as unknown as Event;
    this.updatetime(event, slot, type);
  }

  convertToMinutes(time: Date): number {
    let timeStr: string;

    if (time instanceof Date) {
      const hours = time.getHours().toString().padStart(2, '0');
      const minutes = time.getMinutes().toString().padStart(2, '0');
      timeStr = `${hours}:${minutes}`;
    } else if (typeof time === 'string') {
      timeStr = time;
    } else {
      return 0; // or throw an error if this shouldn't happen
    }

    const [hours, minutes] = timeStr.split(':').map(Number);
    return hours * 60 + minutes;
  }
  applyCopyTime(i: number) {
    const copyvalue = this.weeks[i].slots; // value will catch here of what copy with multi slots
    const indexpaste = this.selectedWeeks;

    if (indexpaste !== null) {
      // mutiple pasete 
      indexpaste.forEach(index => {
        this.weeks[index].slots = [...copyvalue];
      });
    }
  }

  setSelectedWeek(index: number, event: Event) {
    event.stopPropagation();

    if ((event.target as HTMLInputElement).checked) {
      this.selectedWeeks.push(index);
      this.weeks[index].isChecked = true;
    } else {
      this.selectedWeeks = this.selectedWeeks.filter(i => i !== index);
    }

  }

  saveDataSlotwise(): UserAvalibility[] | false {
    const selectedAvailability: UserAvalibility[] = this.weeks
      .filter(item => item.isChecked)
      .flatMap(item =>
        item.slots.map(slot => ({
          userId: this?.userId,                // add userId here
          day: item.day,
          startTime: this.convertToHHMM(slot.startTime),
          endTime: this.convertToHHMM(slot.endTime),
          isActive: true
        }))
      );
    const hasEmptyStartTime = selectedAvailability.some(slot => !slot.startTime || slot.startTime.trim() === "NaN:NaN");
    const hasEmptyEndTime = selectedAvailability.some(slot => !slot.endTime || slot.endTime.trim() === "NaN:NaN");

    if (hasEmptyStartTime || hasEmptyEndTime) {
      this.toastr.error(this.translate.instant('TIME_EMPTY'));
      return false;
    }

    const invalidSlot = selectedAvailability.find(slot => this.convertToMinutes(new Date(slot.startTime)) >= this.convertToMinutes(new Date(slot.endTime)));
    if (invalidSlot) {
      this.toastr.error(this.translate.instant('TIME_COMPARE'));
      return false;
    }

    this.availability.emit(selectedAvailability);
    return selectedAvailability;
  }

  convertToHHMM(time: string): string {
    const date = new Date(time);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;  // 24-hour format
  }

  convertTimeStringToDate(timeStr: string): Date {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  parseTimeToMinutes(timeStr: string): number | null {
    if (!timeStr) return null;
    const [time, modifier] = timeStr.trim().split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    return hours * 60 + minutes;
  }

  endTimeFilter(slot: any): (time: Date) => boolean {
    return (candidateTime: Date): boolean => {
      if (!slot.startTime) return true; // if no start yet, allow all

      const startMins = this.parseTimeToMinutes(slot.startTime);
      const candMins = candidateTime.getHours() * 60 + candidateTime.getMinutes();
      if (startMins == null) return true;
      return candMins > startMins;
    };
  }

  get isDoctor(): boolean {
    return this.userRole?.includes('Doctor') || this.userRole?.includes('AsstDoctor');
  }

  updateSlot() {
    if (!this.isDoctor) return;

    const savedAvailability: UserAvalibility[] | false = this.saveDataSlotwise();

    if (!savedAvailability) {
      return;
    }
    const userId = this.userId;
    const userAvailabilities = savedAvailability;
    const userAvlibilityData: UserAvailabilityPayload = { userId, userAvailabilities };

    this._userService.createUserAvalibility(userAvlibilityData).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.toastr.success(
            this.translate.instant('ENTITY.USERAVAILABILITY') + ' updated successfully'
          );
          // Close dialog or refresh list if needed
        } else {
          const allErrors = Object.values(res.errors || {}).flat();
          this.toastr.error(allErrors.join("\n"));
        }
      },
      error: (err) => {
        this.toastr.error('Something went wrong while updating availability.');
        console.error(err);
      }
    });
  }
}
